import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import cookieHTML from '../cookie-policy.html?raw'

export default function CookiePolicy() {
  const { t } = useTranslation()
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="legal-back">{t('legal.backToApp')}</Link>
        <div dangerouslySetInnerHTML={{ __html: cookieHTML }} />
      </div>
    </div>
  )
}
